import React, { useEffect, useState } from 'react'
import { Button, Checkbox, FormControlLabel, FormGroup, Grid, LinearProgress, TextField, Typography } from '@mui/material'
import { useLocation, useNavigate } from 'react-router'
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import Sidebar from './components/Sidebar';
import i18next from 'i18next';
import FormQuestions from './components/FormQuestions';
import swal from 'sweetalert';
import { postApi } from './api/services';
import { gTagTracking, serviceDown, trackEvent } from './utils/UtilityFunctions';
import MainLoader from './components/MainLoader';
// import FormQuestionsPreview from './components/FormQuestionsPreview';
import { useSelector } from 'react-redux';

const HealthDeclaration = () => {

  const navigate = useNavigate()
  const location = useLocation()
  const [gender, setGender] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [formQuestions, setFormQuestions] = useState([])
  const [formValues, setFormValues] = useState({})
  // const [previewFormQuestions, setPreviewFormQuestions] = useState([])
  const [declarations, setDeclarations] = useState({
    dec1: '',
    dec2: '',
    dec3: '',
    dec4: ''
  })
  const [submitClicked, setSubmitClicked] = useState(false);
  const [formValuesMale, setFormValuesMale] = useState({
    user_id: '',
    date_of_birth: '',
    hair_loss_duration: '',
    hair_loss_pattern: {},
    hair_loss_treatment: {},
    medications: {},
    allergies: {},
    psychological_state: '',
    medical_history: {},
    scalp_conditions: {},
    first_name: '',
    last_name: '',
    email: '',
    document_type: '',
    document_number: '',
    document_issue_country: ''
  });

  const [formValuesFemale, setFormValuesFemale] = useState({
    user_id: '',
    date_of_birth: '',
    menopause_state: '',
    start_of_hair_loss_during_menopause: '',
    hormone_therapy: '',
    hormone_sensitive_breast_cancer: '',
    history_of_endometriosis_or_uterine_fibroids: '',
    depression_or_dosage_of_antidepressants: '',
    allergies: {},
    dutasteride_allergy: '',
    medications: {},
    other_medications: {},
    hair_loss_treatment: {},
    scalp_conditions: '',
    recent_hair_products: '',
    scalp_conditions: {},
    first_name: '',
    last_name: '',
    email: '',
    document_type: '',
    document_number: '',
    document_issue_country: ''
  });

  const [finalUserDetailsQuestions, setFinalUserDetailsQuestions] = useState([])
  const [progress, setProgress] = useState(0)
  const locale = useSelector((state) => state.language.langData);
  let { Gender } = useSelector((state) => state.user.profile);
  
  const formQuestionsMale = [
    {
      title: "Birth Year",
      type: "date",
      placeholder: "Select your date of birth",
      commonIdentifier: "date_of_birth",
      questionId: 1
    },
    {
      title: "How long have you been experiencing hair loss?",
      type: "radio",
      placeholder: "Enter your answer",
      commonIdentifier: "hair_loss_duration",
      optionMap:  {
        option_1: 'Less than three months',
        option_2: 'More than three months' 
      },
      questionId: 2
    },
    {
      title: "Does your hair loss happen in patterns? (Check all that apply)",
      type: "checkbox",
      placeholder: "Select your answer",
      commonIdentifier: "hair_loss_pattern",
      optionMap:  {
        option_1: 'Receding hairline',
        option_2: 'Hair loss on top of skull',
        option_3: 'Hair loss in patches',
        option_4: 'Hair thinning across the scalp',
        option_5: 'Hair shedding (losing more than 100 strands of hair per day)'
      },
      questionId: 3
    },
    {
      title: "Are you currently undergoing any treatment for hair loss?",
      type: "radio",
      placeholder: "Enter your answer",
      commonIdentifier: "hair_loss_treatment",
      optionMap:  {
        option_1: 'Yes',
        option_2: 'No'
      },
      dependentQuestions: [
        {
          title: "Please specify",
          type: "text",
          placeholder: "Enter your answer",
          commonIdentifier: "hair_loss_treatment_dependent",
          selectedOption: ['Yes'],
          subQuestionId: 4
        }
      ],
      questionId: 4
    },
    {
      title: "Are you currently taking any of the following medications: Advodart, Combodart, Duodart, Jalyn, Dutasteride, Proscar, Propecia, Finasteride?",
      type: "radio",
      placeholder: "Enter your answer",
      commonIdentifier: "medications",
      optionMap:  {
        option_1: 'Yes',
        option_2: 'No' 
      },
      dependentQuestions: [
        {
          title: "Please specify",
          type: "text",
          placeholder: "Enter your answer",
          commonIdentifier: "medications_dependent",
          selectedOption: ['Yes'],
          subQuestionId: 5
        }
      ],
      questionId: 5
    },
    {
      title: "Do you experience symptoms of depression or are you currently taking antidepressants?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "psychological_state",
      optionMap:  {
        option_1: 'Yes',
        option_2: 'No' 
      },
      questionId: 6
    },
    {
      title: "Do you have any medication allergies?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "allergies",
      optionMap:  {
        option_1: 'Yes',
        option_2: 'No' 
      },
      dependentQuestions: [
        {
          title: "Please specify",
          type: "text",
          placeholder: "Enter your answer",
          commonIdentifier: "allergies_dependent",
          selectedOption: ['Yes'],
          subQuestionId: 7
        }
      ],
      questionId: 7
    },
    {
      title: "Have you ever had or do you currently have any of the following conditions?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "medical_history",
      optionMap:  {
        option_1: 'Prostate cancer',
        option_2: 'Severe liver failure',
        option_3: 'Other chronic conditions',
        option_4: 'None',
      },
      dependentQuestions: [
        {
          title: "Please specify",
          type: "text",
          placeholder: "Enter your answer",
          commonIdentifier: "medical_history_dependent",
          selectedOption: ['Other chronic conditions'],
          subQuestionId: 8
        }
      ],
      questionId: 8
    },
    {
      title: "Have you ever had or do you currently have any of the following scalp conditions?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "scalp_conditions",
      optionMap:  {
        option_1: 'Eczema',
        option_2: 'Red patches',
        option_3: 'Psoriasis',
        option_4: 'Seborrheic dermatitis',
        option_5: 'None'
      },
      questionId: 9
    },
  ];

  const formQuestionsMaleFr = [
    {
      title: "Année de naissance",
      type: "date",
      placeholder: "Select your date of birth",
      commonIdentifier: "date_of_birth",
      questionId: 1
    },
    {
      title: "Depuis quand observez-vous une chute de cheveux? ",
      type: "radio",
      placeholder: "Enter your answer",
      commonIdentifier: "hair_loss_duration",
      optionMap:  {
        option_1: 'Moins de trois mois',
        option_2: 'Plus de trois mois' 
      },
      questionId: 2
    },
    {
      title: "Suivez-vous actuellement un traitement contre la chute de cheveux? ",
      type: "radio",
      placeholder: "Enter your answer",
      commonIdentifier: "hair_loss_treatment",
      optionMap:  {
        option_1: 'Oui',
        option_2: 'Non'
      },
      dependentQuestions: [
        {
          title: "Si oui, précisez lequel",
          type: "text",
          placeholder: "Enter your answer",
          commonIdentifier: "hair_loss_treatment_dependent",
          selectedOption: ['Oui'],
          subQuestionId: 3
        }
      ],
      questionId: 3
    },
    {
      title: "Prenez-vous actuellement l’un des médicaments suivants : Advocart, Combocart, Dutastéride, Chibro-Proscar, Fincrezo, Propecia, Finastéride?",
      type: "radio",
      placeholder: "Enter your answer",
      commonIdentifier: "medications",
      optionMap:  {
        option_1: 'Oui',
        option_2: 'Non' 
      },
      dependentQuestions: [
        {
          title: "Si oui, précisez lequel",
          type: "text",
          placeholder: "Enter your answer",
          commonIdentifier: "medications_dependent",
          selectedOption: ['Oui'],
          subQuestionId: 4
        }
      ],
      questionId: 4
    },
    {
      title: "Ressentez-vous des symptômes de dépression ou suivez-vous un traitement antidépresseur? ",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "psychological_state",
      optionMap:  {
        option_1: 'Oui',
        option_2: 'Non' 
      },
      questionId: 5
    },
    {
      title: "Êtes-vous allergique à un médicament? ",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "allergies",
      optionMap:  {
        option_1: 'Oui',
        option_2: 'Non' 
      },
      dependentQuestions: [
        {
          title: "Si oui, précisez lequel",
          type: "text",
          placeholder: "Enter your answer",
          commonIdentifier: "allergies_dependent",
          selectedOption: ['Oui'],
          subQuestionId: 6
        }
      ],
      questionId: 6
    },
    {
      title: "Avez-vous ou avez-vous eu l’une des maladies suivantes?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "medical_history",
      optionMap:  {
        option_1: 'Cancer de la prostate',
        option_2: 'Insuffisance hépatique grave',
        option_3: 'Autre pathologie chronique',
        option_4: 'Aucun',
      },
      dependentQuestions: [
        {
          title: "Please specify",
          type: "text",
          placeholder: "Enter your answer",
          commonIdentifier: "medical_history_dependent",
          selectedOption: ['Autre pathologie chronique'],
          subQuestionId: 7
        }
      ],
      questionId: 7
    },
    {
      title: "Avez-vous ou avez-vous eu l’une des affections suivantes au niveau du cuir chevelu?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "scalp_conditions",
      optionMap:  {
        option_1: 'Eczéma',
        option_2: 'Plaques rouges',
        option_3: 'Psoriasis',
        option_4: 'Dermite séborrhéique',
        option_5: 'Aucun'
      },
      questionId: 8
    },
  ];

  const formQuestionsMaleEs = [
    {
      title: "Año de nacimiento",
      type: "date",
      placeholder: "Select your date of birth",
      commonIdentifier: "date_of_birth",
      questionId: 1
    },
    {
      title: "¿Desde cuándo notas la caída del cabello?",
      type: "radio",
      placeholder: "Enter your answer",
      commonIdentifier: "hair_loss_duration",
      optionMap:  {
        option_1: 'Menos de tres meses',
        option_2: 'Más de tres meses' 
      },
      questionId: 2
    },
    {
      title: "¿Estás siguiendo actualmente algún tratamiento contra la caída del cabello?",
      type: "radio",
      placeholder: "Enter your answer",
      commonIdentifier: "hair_loss_treatment",
      optionMap:  {
        option_1: 'Sí',
        option_2: 'No'
      },
      dependentQuestions: [
        {
          title: "En caso afirmativo, especifique",
          type: "text",
          placeholder: "Enter your answer",
          commonIdentifier: "hair_loss_treatment_dependent",
          selectedOption: ['Sí'],
          subQuestionId: 3
        }
      ],
      questionId: 3
    },
    {
      title: "¿Estás tomando actualmente alguno de los siguientes medicamentos: Adivart, Urocont, Dutasteride, Arehormo, Biturol, Capikern, Celganol, Litace, Predser, Finasteride?",
      type: "radio",
      placeholder: "Enter your answer",
      commonIdentifier: "medications",
      optionMap:  {
        option_1: 'Sí',
        option_2: 'No' 
      },
      dependentQuestions: [
        {
          title: "En caso afirmativo, especifique",
          type: "text",
          placeholder: "Enter your answer",
          commonIdentifier: "medications_dependent",
          selectedOption: ['Sí'],
          subQuestionId: 4
        }
      ],
      questionId: 4
    },
    {
      title: "¿Sufres síntomas de depresión o estás bajo tratamiento con antidepresivos?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "psychological_state",
      optionMap:  {
        option_1: 'Sí',
        option_2: 'No' 
      },
      questionId: 5
    },
    {
      title: "¿Eres alérgico a algún medicamento?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "allergies",
      optionMap:  {
        option_1: 'Sí',
        option_2: 'No' 
      },
      dependentQuestions: [
        {
          title: "En caso afirmativo, especifique",
          type: "text",
          placeholder: "Enter your answer",
          commonIdentifier: "allergies_dependent",
          selectedOption: ['Sí'],
          subQuestionId: 6
        }
      ],
      questionId: 6
    },
    {
      title: "¿Has tenido o tienes alguna de las siguientes enfermedades?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "medical_history",
      optionMap:  {
        option_1: 'Cáncer de próstata',
        option_2: 'Insuficiencia hepática grave',
        option_3: 'Otra patología crónica',
        option_4: 'Ninguno',
      },
      dependentQuestions: [
        {
          title: "En caso afirmativo, especifique",
          type: "text",
          placeholder: "Enter your answer",
          commonIdentifier: "medical_history_dependent",
          selectedOption: ['Otra patología crónica'],
          subQuestionId: 7
        }
      ],
      questionId: 7
    },
    {
      title: "¿Has tenido o tienes alguna de las siguientes afecciones en el cuero cabelludo?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "scalp_conditions",
      optionMap:  {
        option_1: 'Eccema',
        option_2: 'Manchas rojas',
        option_3: 'Psoriasis',
        option_4: 'Dermatitis seborreica',
        option_5: 'Ninguno'
      },
      questionId: 8
    },
  ];

  const formQuestionsFemale = [
    {
      title: "Birth Year",
      type: "date",
      placeholder: "Select your date of birth",
      commonIdentifier: "date_of_birth",
      questionId: 1
    },
    {
      title: "Kindly confirm if you have reached menopause (defined as no menstrual periods for last 12 consecutive months). This is important to ensure treatment safety.",
      type: "radio",
      placeholder: "Enter your answer",
      commonIdentifier: "menopause_state",
      optionMap:  {
        option_1: 'Yes, I have reached menopause',
        option_2: 'No, I have not reached menopause' 
      },
      note: `Dutasteride, a key component of the hair loss treatment, can harm a developing baby and cause malformations; so it's contraindicated for women who may become pregnant. Confirming you've reached menopause is essential so that dutasteride can be used safely and responsibly.`,
      questionId: 2
    },
    {
      title: "Has your hair loss started during or after menopause?",
      type: "radio",
      placeholder: "Enter your answer",
      commonIdentifier: "start_of_hair_loss_during_menopause",
      optionMap:  {
        option_1: 'Yes',
        option_2: 'No, it started before menopause' 
      },
      questionId: 3
    },
    {
      title: "Are you currently undergoing any hormone therapy for menopause?",
      type: "radio",
      placeholder: "Enter your answer",
      commonIdentifier: "hormone_therapy",
      optionMap:  {
        option_1: 'Yes',
        option_2: 'No' 
      },
      questionId: 4
    },
    {
      title: "Have you ever had hormone-sensitive breast cancer?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "hormone_sensitive_breast_cancer",
      optionMap:  {
        option_1: 'Yes',
        option_2: 'No' 
      },
      questionId: 5
    },
    {
      title: "Do you have a history of endometriosis or uterine fibroids?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "history_of_endometriosis_or_uterine_fibroids",
      optionMap:  {
        option_1: 'Yes',
        option_2: 'No' 
      },
      questionId: 6
    },
    {
      title: "Have you ever been diagnosed with depression or are you currently taking antidepressants?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "depression_or_dosage_of_antidepressants",
      optionMap:  {
        option_1: 'Yes',
        option_2: 'No',
      },
      questionId: 7
    },
    {
      title: "Do you have any medication allergies?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "allergies",
      optionMap:  {
        option_1: 'Yes',
        option_2: 'No',
      },
      dependentQuestions: [
        {
          title: "Please specify",
          type: "text",
          placeholder: "Enter your answer",
          commonIdentifier: "allergies_dependent",
          selectedOption: ['Yes'],
          subQuestionId: 8
        }
      ],
      questionId: 8
    },
    {
      title: "Do you have a known allergy to Dutasteride?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "dutasteride_allergy",
      optionMap:  {
        option_1: 'Yes',
        option_2: 'No',
      },
      questionId: 9
    },
    {
      title: "Are you currently taking any medications?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "medications",
      optionMap:  {
        option_1: 'Yes',
        option_2: 'No',
      },
      note: `Please list all. Especially mention if you take ketoconazole, verapamil, or ritonavir. If known, include both brand and generic names`,
      dependentQuestions: [
        {
          title: "Please specify",
          type: "text",
          placeholder: "Enter your answer",
          commonIdentifier: "medications_dependent",
          selectedOption: ['Yes'],
          subQuestionId: 10
        }
      ],
      questionId: 10
    },
    {
      title: "Are you currently taking any of the following medications: Advodart, Combodart, Duodart, Jalyn, Dutasteride, Proscar, Propecia, Finasteride?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "other_medications",
      optionMap:  {
        option_1: 'Yes',
        option_2: 'No',
      },
      dependentQuestions: [
        {
          title: "Please specify",
          type: "text",
          placeholder: "Enter your answer",
          commonIdentifier: "other_medications_dependent",
          selectedOption: ['Yes'],
          subQuestionId: 11
        }
      ],
      questionId: 11
    },
    {
      title: "Are you currently undergoing any treatment for hair loss?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "hair_loss_treatment",
      optionMap:  {
        option_1: 'Yes',
        option_2: 'No',
      },
      dependentQuestions: [
        {
          title: "Please specify",
          type: "text",
          placeholder: "Enter your answer",
          commonIdentifier: "hair_loss_treatment_dependent",
          selectedOption: ['Yes'],
          subQuestionId: 12
        }
      ],
      questionId: 12
    },
    {
      title: "Have you ever had or do you currently have any scalp conditions?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "scalp_conditions",
      optionMap:  {
        option_1: 'Eczema',
        option_2: 'Red patches',
        option_3: 'Seborrheic dermatitis',
        option_4: 'Psoriasis',
        option_5: 'None'
      },
      questionId: 13
    },
    {
      title: "Have you recently applied any hair or scalp products such as thickening sprays, keratin treatments, styling agents, oils, or serums?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "recent_hair_products",
      optionMap:  {
        option_1: 'Yes',
        option_2: 'No',
      },
      note: `Please note: These products may reduce the effectiveness of your treatment if they block absorption at the scalp. It's important that the scalp is clean and product-free before applying your prescription.`,
      questionId: 14
    },
  ];

  const formQuestionsFemaleFr = [
    {
      title: "Année de naissance",
      type: "date",
      placeholder: "Sélectionnez votre date de naissance",
      commonIdentifier: "date_of_birth",
      questionId: 1
    },
    {
      title: "Pouvez-vous confirmer que vous êtes ménopausé",
      type: "radio",
      placeholder: "Enter your answer",
      commonIdentifier: "menopause_state",
      optionMap:  {
        option_1: 'Oui, j’ai atteint la ménopause',
        option_2: 'Non, je n’ai pas encore atteint la ménopause' 
      },
      note: `La ménopause est définie comme l’absence de règles pendant 12 mois consécutifs. Le Dutastéride, un composant clé du traitement, peut nuire au développement d’un fœtus. Il ne doit surtout pas être utilisé chez les femmes susceptibles d’être enceintes. Confirmer que vous avez atteint la ménopause est essentiel pour garantir l’utilisation du Dutastéride de manière sûre et responsable. `,
      questionId: 2
    },
    {
      title: "Votre chute de cheveux a-t-elle commencé pendant ou après la ménopause? ",
      type: "radio",
      placeholder: "Enter your answer",
      commonIdentifier: "start_of_hair_loss_during_menopause",
      optionMap:  {
        option_1: 'Oui',
        option_2: 'Non, elle a commencé avant la mànopause' 
      },
      questionId: 3
    },
    {
      title: "Suivez-vous actuellement un traitement hormonal substitutive pour la ménopaus?",
      type: "radio",
      placeholder: "Enter your answer",
      commonIdentifier: "hormone_therapy",
      optionMap:  {
        option_1: 'Oui',
        option_2: 'Non' 
      },
      questionId: 4
    },
    {
      title: "Avez-vous déjà eu un cancer du sein hormone-dépendant?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "hormone_sensitive_breast_cancer",
      optionMap:  {
        option_1: 'Oui',
        option_2: 'Non' 
      },
      questionId: 5
    },
    {
      title: "Avez-vous des antécédents d’endométriose ou de fibromes utérins?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "history_of_endometriosis_or_uterine_fibroids",
      optionMap:  {
        option_1: 'Oui',
        option_2: 'Non' 
      },
      questionId: 6
    },
    {
      title: "Avez-vous déjà été diagnostiquée pour une dépression ou prenez-vous actuellement des antidépresseurs?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "depression_or_dosage_of_antidepressants",
      optionMap:  {
        option_1: 'Oui',
        option_2: 'Non',
      },
      questionId: 7
    },
    {
      title: "Êtes-vous allergique à certains médicaments?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "allergies",
      optionMap:  {
        option_1: 'Oui',
        option_2: 'Non',
      },
      dependentQuestions: [
        {
          title: "si oui, merci de préciser",
          type: "text",
          placeholder: "Enter your answer",
          commonIdentifier: "allergies_dependent",
          selectedOption: ['Oui'],
          subQuestionId: 8
        }
      ],
      questionId: 8
    },
    {
      title: "Avez-vous une allergie connue au Dutastéride?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "dutasteride_allergy",
      optionMap:  {
        option_1: 'Oui',
        option_2: 'Non',
      },
      questionId: 9
    },
    {
      title: "Prenez-vous actuellement des médicaments?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "medications",
      optionMap:  {
        option_1: 'Oui',
        option_2: 'Non',
      },
      note: `Merci d’indiquer tous les médicaments que vous prenez. Veuillez mentionner notamment si vous prenez du kétoconazole, du vérapamil ou du ritonavir. Si possible, indiquez le nom commercial et le nom générique.`,
      dependentQuestions: [
        {
          title: "si oui, merci de préciser",
          type: "text",
          placeholder: "Enter your answer",
          commonIdentifier: "medications_dependent",
          selectedOption: ['Oui'],
          subQuestionId: 10
        }
      ],
      questionId: 10
    },
    {
      title: "Prenez-vous l’un des médicaments suivants : Advodart, Combodart, Duodart, Jalyn, Dutastéride, Proscar, Propecia, Finastéride?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "other_medications",
      optionMap:  {
        option_1: 'Oui',
        option_2: 'Non',
      },
      dependentQuestions: [
        {
          title: "Si vous avez répondu oui, merci de préciser",
          type: "text",
          placeholder: "Enter your answer",
          commonIdentifier: "other_medications_dependent",
          selectedOption: ['Oui'],
          subQuestionId: 11
        }
      ],
      questionId: 11
    },
    {
      title: "Suivez-vous actuellement un traitement contre la chute de cheveux?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "hair_loss_treatment",
      optionMap:  {
        option_1: 'Oui',
        option_2: 'Non',
      },
      dependentQuestions: [
        {
          title: "si oui, merci de préciser",
          type: "text",
          placeholder: "Enter your answer",
          commonIdentifier: "hair_loss_treatment_dependent",
          selectedOption: ['Oui'],
          subQuestionId: 12
        }
      ],
      questionId: 12
    },
    {
      title: "Souffrez-vous ou avez-vous souffert de l’un des problèmes suivants au niveau du cuir chevelu?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "scalp_conditions",
      optionMap:  {
        option_1: 'Eczéma',
        option_2: 'Plaques rouges',
        option_3: 'Dermatite séborrhéique',
        option_4: 'Psoriasis',
        option_5: 'Aucun'
      },
      questionId: 13
    },
    {
      title: "Avez-vous récemment appliqué des produits sur vos cheveux ou votre cuir chevelu (comme des sprays densifiants, des traitements à la kératine, des produits coiffants, des huiles ou des sérums)?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "recent_hair_products",
      optionMap:  {
        option_1: 'Oui',
        option_2: 'Non',
      },
      note: `Ces produits peuvent limiter l’absorption du traitement et en réduire l’efficacité. Pour des résultats optimaux, il est important d’appliquer le traitement sur un cuir chevelu propre, sans résidus.`,
      questionId: 14
    },
  ];

  const formQuestionsFemaleEs = [
    {
      title: "Año de nacimiento",
      type: "date",
      placeholder: "Select your date of birth",
      commonIdentifier: "date_of_birth",
      questionId: 1
    },
    {
      title: "Confirme, por favor, si ha alcanzado la menopausia (definida como la ausencia de menstruación durante los últimos 12 meses consecutivos). Esto es importante para garantizar la seguridad del tratamiento.",
      type: "radio",
      placeholder: "Enter your answer",
      commonIdentifier: "menopause_state",
      optionMap:  {
        option_1: 'Sí, he alcanzado la menopausia',
        option_2: 'No, no he alcanzado la menopausia' 
      },
      note: `El Dutasteride, un componente clave del tratamiento contra la caída del cabello, puede dañar al feto en desarrollo y causar malformaciones; por lo tanto, está contraindicado en mujeres que puedan quedar embarazadas. Confirmar que usted ha alcanzado la menopausia es esencial para que el Dutasteride pueda utilizarse de manera segura y responsable.`,
      questionId: 2
    },
    {
      title: "¿La caída de su cabello comenzó durante o después de la menopausia?",
      type: "radio",
      placeholder: "Enter your answer",
      commonIdentifier: "start_of_hair_loss_during_menopause",
      optionMap:  {
        option_1: 'Sí, comenzó con la menopausia',
        option_2: 'No, comenzó antes de la menopausia' 
      },
      questionId: 3
    },
    {
      title: "¿Está actualmente en tratamiento hormonal para la menopausia?",
      type: "radio",
      placeholder: "Enter your answer",
      commonIdentifier: "hormone_therapy",
      optionMap:  {
        option_1: 'Sí',
        option_2: 'No' 
      },
      questionId: 4
    },
    {
      title: "¿Ha tenido alguna vez cáncer de mama sensible a las hormonas?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "hormone_sensitive_breast_cancer",
      optionMap:  {
        option_1: 'Sí',
        option_2: 'No' 
      },
      questionId: 5
    },
    {
      title: "¿Tiene antecedentes de endometriosis o fibromas uterinos?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "history_of_endometriosis_or_uterine_fibroids",
      optionMap:  {
        option_1: 'Sí',
        option_2: 'No' 
      },
      questionId: 6
    },
    {
      title: "¿Alguna vez le han diagnosticado depresión o está actualmente en tratamiento con antidepresivos?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "depression_or_dosage_of_antidepressants",
      optionMap:  {
        option_1: 'Sí',
        option_2: 'No',
      },
      questionId: 7
    },
    {
      title: "¿Tiene alergia a algún medicamento?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "allergies",
      optionMap:  {
        option_1: 'Sí',
        option_2: 'No',
      },
      dependentQuestions: [
        {
          title: "En caso afirmativo, especifique",
          type: "text",
          placeholder: "Enter your answer",
          commonIdentifier: "allergies_dependent",
          selectedOption: ['Sí'],
          subQuestionId: 8
        }
      ],
      questionId: 8
    },
    {
      title: "¿Tiene alergia conocida al Dutasteride?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "dutasteride_allergy",
      optionMap:  {
        option_1: 'Sí',
        option_2: 'No',
      },
      questionId: 9
    },
    {
      title: "¿Está tomando actualmente algún medicamento?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "medications",
      optionMap:  {
        option_1: 'Sí',
        option_2: 'No',
      },
      note: `Indique todos los que toma. Mencione especialmente si utiliza ketoconazol, verapamilo o ritonavir. Si lo sabe, incluya tanto el nombre comercial como el nombre genérico.`,
      dependentQuestions: [
        {
          title: "En caso afirmativo, especifique",
          type: "text",
          placeholder: "Enter your answer",
          commonIdentifier: "medications_dependent",
          selectedOption: ['Sí'],
          subQuestionId: 10
        }
      ],
      questionId: 10
    },
    {
      title: "¿Está tomando actualmente alguno de los siguientes medicamentos: Advodart, Combodart, Duodart, Jalyn, Dutasteride, Proscar, Propecia, Finasteride?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "other_medications",
      optionMap:  {
        option_1: 'Sí',
        option_2: 'No',
      },
      dependentQuestions: [
        {
          title: "En caso afirmativo, especifique",
          type: "text",
          placeholder: "Enter your answer",
          commonIdentifier: "other_medications_dependent",
          selectedOption: ['Sí'],
          subQuestionId: 11
        }
      ],
      questionId: 11
    },
    {
      title: "¿Está actualmente en tratamiento contra la caída del cabello?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "hair_loss_treatment",
      optionMap:  {
        option_1: 'Sí',
        option_2: 'No',
      },
      dependentQuestions: [
        {
          title: "En caso afirmativo, especifique",
          type: "text",
          placeholder: "Enter your answer",
          commonIdentifier: "hair_loss_treatment_dependent",
          selectedOption: ['Sí'],
          subQuestionId: 12
        }
      ],
      questionId: 12
    },
    {
      title: "¿Ha tenido o tiene actualmente alguna de las siguientes afecciones en el cuero cabelludo?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "scalp_conditions",
      optionMap:  {
        option_1: 'Eccema',
        option_2: 'Manchas rojas',
        option_3: 'Dermatitis seborreica',
        option_4: 'Psoriasis',
        option_5: 'Ninguna'
      },
      questionId: 13
    },
    {
      title: "¿Ha aplicado recientemente algún producto sobre su cabello o cuero cabelludo, como sprays voluminizadores, tratamientos de queratina, productos de peinado, aceites o sueros?",
      type: "radio",
      placeholder: "Select your answer",
      commonIdentifier: "recent_hair_products",
      optionMap:  {
        option_1: 'Sí',
        option_2: 'No',
      },
      note: `Estos productos pueden reducir la eficacia de su tratamiento si bloquean la absorción a nivel del cuero cabelludo. Es importante que el cuero cabelludo esté limpio y libre de productos antes de aplicar su fórmula prescrita.`,
      questionId: 14
    },
  ];

  const userDetailsQuestions = [
    {
      title: "First Name",
      type: "text",
      placeholder: "Enter your first name",
      commonIdentifier: "first_name",
      questionId: 1
    },
    {
      title: "Last Name",
      type: "text",
      placeholder: "Enter your last name",
      commonIdentifier: "last_name",
      questionId: 2
    },
    {
      title: "Email",
      type: "email",
      placeholder: "Enter your email",
      commonIdentifier: "email",
      questionId: 3
    },
    {
      title: "Document",
      type: "dropdown",
      placeholder: "Enter your email",
      commonIdentifier: "document_type",
      questionId: 4
    },
    {
      title: "Document Number",
      type: "text",
      placeholder: "Enter Your Document Number",
      commonIdentifier: "document_number",
      questionId: 5
    },
    {
      title: "Document Issue Country",
      type: "dropdown",
      placeholder: "Select country",
      commonIdentifier: "document_issue_country",
      questionId: 6
    },
  ]

  const userDetailsQuestionsFr = [
    {
      title: "Prénom",
      type: "text",
      placeholder: "Entrez votre prénom",
      commonIdentifier: "first_name",
      questionId: 1
    },
    {
      title: "Nom de famille",
      type: "text",
      placeholder: "Entrez votre nom de famille",
      commonIdentifier: "last_name",
      questionId: 2
    },
    {
      title: "Adresse e-mail",
      type: "email",
      placeholder: "Entrez votre email",
      commonIdentifier: "email",
      questionId: 3
    },
    {
      title: "Document d’identité",
      type: "dropdown",
      placeholder: "Sélectionnez votre document",
      commonIdentifier: "document_type",
      questionId: 4
    },
    {
      title: "Numéro du document",
      type: "text",
      placeholder: "Entrez votre numéro de document",
      commonIdentifier: "document_number",
      questionId: 5
    },
    {
      title: "Pays d’émission du document",
      type: "dropdown",
      placeholder: "Sélectionnez un pays",
      commonIdentifier: "document_issue_country",
      questionId: 6
    },
  ]

  const userDetailsQuestionsEs = [
    {
      title: "Nombre",
      type: "text",
      placeholder: "Introduce tu nombre",
      commonIdentifier: "first_name",
      questionId: 1
    },
    {
      title: "Apellido",
      type: "text",
      placeholder: "Introduce tu apellido",
      commonIdentifier: "last_name",
      questionId: 2
    },
    {
      title: "Correo electrónico",
      type: "email",
      placeholder: "Introduce tu correo electrónico",
      commonIdentifier: "email",
      questionId: 3
    },
    {
      title: "Documento de identidad",
      type: "dropdown",
      placeholder: "Selecciona tu documento",
      commonIdentifier: "document_type",
      questionId: 4
    },
    {
      title: "Número del documento",
      type: "text",
      placeholder: "Ingrese su número de documento",
      commonIdentifier: "document_number",
      questionId: 5
    },
    {
      title: "País de emisión del documento",
      type: "dropdown",
      placeholder: "Seleccionar país",
      commonIdentifier: "document_issue_country",
      questionId: 6
    },
  ]

  useEffect(() => {
    let gender = ''
    if(Gender == ''){
      setGender(localStorage.getItem('gender'))
      gender = localStorage.getItem('gender')
    } else {
      setGender(Gender)
      gender = Gender
    }
    if(gender.toUpperCase() === 'MALE') {
      locale && locale === 'fr' ? setFormQuestions(formQuestionsMaleFr) : locale && locale == 'es' ? setFormQuestions(formQuestionsMaleEs) : setFormQuestions(formQuestionsMale)
      locale && locale === 'fr' ? setFinalUserDetailsQuestions(userDetailsQuestionsFr) : locale && locale == 'es' ? setFinalUserDetailsQuestions(userDetailsQuestionsEs) : setFinalUserDetailsQuestions(userDetailsQuestions)
      setFormValues(formValuesMale)
    } else if(gender.toUpperCase() === 'FEMALE') {
      locale && locale === 'fr' ? setFormQuestions(formQuestionsFemaleFr) : locale && locale == 'es' ? setFormQuestions(formQuestionsFemaleEs) : setFormQuestions(formQuestionsFemale)
      locale && locale === 'fr' ? setFinalUserDetailsQuestions(userDetailsQuestionsFr) : locale && locale == 'es' ? setFinalUserDetailsQuestions(userDetailsQuestionsEs) : setFinalUserDetailsQuestions(userDetailsQuestions)
      setFormValues(formValuesFemale)
    }
    if(location?.state?.user_obj?.gender && location.state.user_obj.gender){
      setGender(location.state.user_obj.gender)
      // if (location?.state?.user_obj?.medical_history_present && location.state.user_obj.medical_history_present) {
      //   getHealthAnalysis()
      // }
      if(location.state.user_obj.gender.toUpperCase() === 'MALE') {
        locale && locale === 'fr' ? setFormQuestions(formQuestionsMaleFr) : locale && locale == 'es' ? setFormQuestions(formQuestionsMaleEs) : setFormQuestions(formQuestionsMale)
        setFormValues(formValuesMale)
      } else if(location.state.user_obj.gender.toUpperCase() === 'FEMALE') {
        locale && locale === 'fr' ? setFormQuestions(formQuestionsFemaleFr) : locale && locale == 'es' ? setFormQuestions(formQuestionsFemaleEs) : setFormQuestions(formQuestionsFemale)
        setFormValues(formValuesFemale)
      }
    }
  }, [locale])

  useEffect(() => {
    setProgress(calculateProgress());
  }, [formValuesMale, formValuesFemale, gender]);


  const countFilledFields = (formValues) => {
    return Object.entries(formValues)
      .filter(([key]) => key !== "user_id") // ignore user_id
      .filter(([_, value]) => !isInvalid(value)) // count only valid values
      .length;
  };

  const totalFields = (formValues) => {
    return Object.keys(formValues).filter((key) => key !== "user_id").length;
  };


  const calculateProgress = () => {
    const values = gender.toUpperCase() === "MALE"
      ? formValuesMale
      : formValuesFemale;

    const filled = countFilledFields(values);
    const total = totalFields(values);

    return Math.round((filled / total) * 100);
  };



  // useEffect(() => {
  //   console.log("previewFormQuestions", previewFormQuestions)
  // }, [previewFormQuestions])

  // const getHealthAnalysis = async () => {
  //   setIsLoading(true)
  //   let params = {
  //     user_id: location.state.user_obj.user_id
  //     // user_id: 1
  //   }
  //   console.log('get_medical_history_for_user params', params);
  //   try {
  //     let res = await postApi('get_medical_history_for_user', params)
  //     if(res){
  //       setIsLoading(false)
  //       console.log('get_medical_history_for_user res', res); 
  //       const yesByLocale = {
  //         fr: "Oui",
  //         es: "Sí",
  //         en: "Yes"
  //       };
  //       const key = yesByLocale[locale] || "Yes";
  //       res.medications = {[key] : 'dependent'}
  //       Object.keys(res).length > 0 && Object.keys(res).map((k) => {
  //         addValues(k, res[k])
  //       })
  //     }
  //   } catch (err) {
  //     console.log("err", err);
  //     setIsLoading(false)
  //     serviceDown()
  //   }
  // }

  // const addValues = (key, val) => {
  //   let formQues = 
  //     location.state.user_obj.gender.toUpperCase() === 'MALE' && locale && locale == 'en' ? 
  //       formQuestionsMale 
  //         :
  //     location.state.user_obj.gender.toUpperCase() === 'MALE' && locale && locale == 'fr' ? 
  //         formQuestionsMaleFr 
  //           :
  //     location.state.user_obj.gender.toUpperCase() === 'MALE' && locale && locale == 'es' ? 
  //         formQuestionsMaleEs 
  //           :
  //     location.state.user_obj.gender.toUpperCase() === 'FEMALE' && locale && locale === 'fr' ? 
  //         formQuestionsFemaleFr 
  //           : 
  //     location.state.user_obj.gender.toUpperCase() === 'FEMALE' && locale && locale == 'es' ? 
  //         formQuestionsFemaleEs 
  //           : 
  //         formQuestionsFemale
  //   formQues.length > 0 && formQues.forEach((qObj) => {
  //     if (qObj.commonIdentifier === key) {
  //       if(typeof val === 'object' && qObj?.dependentQuestions?.length > 0) {
  //         qObj.dependentQuestions[0]['value'] = Object.values(val)[0]
  //         qObj['value'] = Object.keys(val)[0]
  //       } else {
  //         qObj['value'] = val;
  //       }
  //       setPreviewFormQuestions(prev => [...prev, qObj]); 
  //     }
  //   });
  // };

  const handleFormValues = (value, identifier, parent) => {
    let finalVal = {}
    if (
      identifier === 'hair_loss_treatment' || 
      identifier === 'medications' ||
      identifier === 'allergies' ||
      identifier === 'medical_history' ||
      identifier === 'allergies' ||
      identifier === 'other_medications'
    ) {
      if(value.toUpperCase() === 'NO'){
        finalVal[`${value}`] = value
      } else if(value.toUpperCase() === 'YES'){
        finalVal[`${value}`] = ''
      } else {
        finalVal[`${value}`] = value
      }
    } else if (
      identifier === 'medications_dependent' ||
      identifier === 'allergies_dependent' ||
      identifier === 'medical_history_dependent' ||
      identifier === 'allergies_dependent' ||
      identifier === 'other_medications_dependent'
    ) {
      const yesByLocale = {
        fr: "Oui",
        es: "Sí",
        en: "Yes"
      };
      const key = yesByLocale[locale] || "Yes";
      finalVal[key] = value
    } else if (
      identifier === 'hair_loss_treatment_dependent'
    ) {
      finalVal[parent.selectedParent] = value
    } else if (
      identifier === 'scalp_conditions'
    ) {
      finalVal[`${value}`] = value
    } else {
      finalVal = value
    } 

    if(gender.toUpperCase() === 'MALE') {
      setFormValuesMale((prev) => {
        const updated = { ...prev };

        switch (identifier) {
          case "date_of_birth" :
            updated.date_of_birth = finalVal;
            break; // FIX: Added missing break to prevent fall-through
          case "hair_loss_treatment":
            updated.hair_loss_treatment = finalVal;
            break;
          case "hair_loss_treatment_dependent":
            updated.hair_loss_treatment = finalVal;
            break;
          case "medications":
            updated.medications = finalVal;
            break;
          case "medications_dependent":
            updated.medications = finalVal;
            break;
          case "allergies":
            updated.allergies = finalVal;
            break;
          case "allergies_dependent":
            updated.allergies = finalVal;
            break;
          case "hair_loss_duration":
            updated.hair_loss_duration = finalVal;
            break;
          case "hair_loss_pattern":
            updated.hair_loss_pattern = finalVal;
            break;
          case "psychological_state":
            updated.psychological_state = finalVal;
            break;
          case "medical_history":
            updated.medical_history = finalVal;
            break;
          case "medical_history_dependent":
            updated.medical_history = finalVal;
            break;
          case "scalp_conditions":
            updated.scalp_conditions = finalVal;
            break;
          case "first_name":
            updated.first_name = finalVal;
            break;
          case "last_name":
            updated.last_name = finalVal;
            break;
          case "email":
            updated.email = finalVal;
            break;
          case "document_type":
            updated.document_type = finalVal;
            break;
          case "document_number":
            updated.document_number = finalVal;
            break;
          case "document_issue_country":
            updated.document_issue_country = finalVal;
            break;
          default:
            break;
        }
        return updated;
      });
    } else {
      setFormValuesFemale((prev) => {
        const updated = { ...prev };

        switch (identifier) {
          case "date_of_birth" :
            updated.date_of_birth = finalVal;
            break; // FIX: Added missing break to prevent fall-through
          case "menopause_state":
            updated.menopause_state = finalVal;
            break;
          case "start_of_hair_loss_during_menopause":
            updated.start_of_hair_loss_during_menopause = finalVal;
            break;
          case "hormone_therapy":
            updated.hormone_therapy = finalVal;
            break;
          case "hormone_sensitive_breast_cancer":
            updated.hormone_sensitive_breast_cancer = finalVal;
            break;
          case "history_of_endometriosis_or_uterine_fibroids":
            updated.history_of_endometriosis_or_uterine_fibroids = finalVal;
            break;
          case "depression_or_dosage_of_antidepressants":
            updated.depression_or_dosage_of_antidepressants = finalVal;
            break;
          case "allergies":
            updated.allergies = finalVal;
            break;
          case "allergies_dependent":
            updated.allergies = finalVal;
            break;
          case "dutasteride_allergy":
            updated.dutasteride_allergy = finalVal;
            break;
          case "medications":
            updated.medications = finalVal;
            break;
          case "medications_dependent":
            updated.medications = finalVal;
            break;
          case "other_medications":
            updated.other_medications = finalVal;
            break;
          case "other_medications_dependent":
            updated.other_medications = finalVal;
            break;
          case "hair_loss_treatment":
            updated.hair_loss_treatment = finalVal;
            break;
          case "hair_loss_treatment_dependent":
            updated.hair_loss_treatment = finalVal;
            break;
          case "scalp_conditions":
            updated.scalp_conditions = finalVal;
            break;
          case "recent_hair_products":
            updated.recent_hair_products = finalVal;
            break;
          case "first_name":
            updated.first_name = finalVal;
            break;
          case "last_name":
            updated.last_name = finalVal;
            break;
          case "email":
            updated.email = finalVal;
            break;
          case "document_type":
            updated.document_type = finalVal;
            break;
          case "document_number":
            updated.document_number = finalVal;
            break;
          case "document_issue_country":
            updated.document_issue_country = finalVal;
            break;
          default:
            break;
        }
        return updated;
      });
    }
  }
  
  const handleDeclaration = (value, identifier) => {
    setDeclarations((prev) => {
      const updated = { ...prev };

      switch (identifier) {
        case "dec1":
          updated.dec1 = value;
          break;
        case "dec2":
          updated.dec2 = value;
          break;
        case "dec3":
          updated.dec3 = value;
          break;
        case "dec4":
          updated.dec4 = value;
          break;
        default:
          break;
      }
      return updated;
    });
  }

  // const isInvalid = (value) => {
  //   // Case 1: string -> empty ❌
  //   if (typeof value === "string") {
  //     return value?.trim() === "";
  //   }

  //    // Case 2: number
  //   if (typeof value === "number") {
  //     return value === null || value === undefined || Number.isNaN(value);
  //   }

  //   // Case 2: object -> any key value is empty ❌
  //   if (typeof value === "object" && value !== null) {
  //     return Object.values(value).some(v => v === "" || v === null || v === undefined);
  //   }

  //   return false; // everything else assumed valid
  // };  

  const isInvalid = (value) => {
    // Case 1: string
    if (typeof value === "string") {
      return value.trim() === "";
    }

    // Case 2: number
    if (typeof value === "number") {
      return value === null || value === undefined || Number.isNaN(value);
    }

    // Case 3: object ({} or {Yes: ""})
    if (typeof value === "object" && value !== null) {
      const values = Object.values(value);
      if (values.length === 0) return true; // {} → invalid

      return values.some(
        (v) =>
          v === "" ||
          v === null ||
          v === undefined ||
          (typeof v === "number" && Number.isNaN(v))
      );
    }

    return false;
  };


  const handleSubmit = async () => {
    let userId = JSON.parse(localStorage.getItem('user_id'));
    setSubmitClicked(true);
    if(
      (gender.toUpperCase () === 'MALE' && (
        isInvalid(formValuesMale.date_of_birth) ||
        isInvalid(formValuesMale.hair_loss_treatment) ||
        isInvalid(formValuesMale.medications) ||
        isInvalid(formValuesMale.allergies) ||
        isInvalid(formValuesMale.hair_loss_duration) ||
        isInvalid(formValuesMale.hair_loss_pattern) ||
        isInvalid(formValuesMale.psychological_state) ||
        isInvalid(formValuesMale.medical_history) ||
        isInvalid(formValuesMale.scalp_conditions) ||
        isInvalid(formValuesMale.first_name) ||
        isInvalid(formValuesMale.last_name) ||
        isInvalid(formValuesMale.email) ||
        isInvalid(formValuesMale.document_type) ||
        isInvalid(formValuesMale.document_number) ||
        isInvalid(formValuesMale.document_issue_country)
      )) ||
      (gender.toUpperCase () === 'FEMALE' && (
        isInvalid(formValuesFemale.date_of_birth) ||
        isInvalid(formValuesFemale.menopause_state) ||
        isInvalid(formValuesFemale.start_of_hair_loss_during_menopause) ||
        isInvalid(formValuesFemale.hormone_therapy) ||
        isInvalid(formValuesFemale.hormone_sensitive_breast_cancer) ||
        isInvalid(formValuesFemale.history_of_endometriosis_or_uterine_fibroids) ||
        isInvalid(formValuesFemale.depression_or_dosage_of_antidepressants) ||
        isInvalid(formValuesFemale.allergies) ||
        isInvalid(formValuesFemale.dutasteride_allergy) ||
        isInvalid(formValuesFemale.medications) ||
        isInvalid(formValuesFemale.other_medications) ||
        isInvalid(formValuesFemale.hair_loss_treatment) ||
        isInvalid(formValuesFemale.scalp_conditions) ||
        isInvalid(formValuesFemale.recent_hair_products) ||
        isInvalid(formValuesFemale.first_name) ||
        isInvalid(formValuesFemale.last_name) ||
        isInvalid(formValuesFemale.email) ||
        isInvalid(formValuesFemale.document_type) ||
        isInvalid(formValuesFemale.document_number) ||
        isInvalid(formValuesFemale.document_issue_country)
      ))
    ) {
      swal({
        title: i18next.t("Please fill all the fields"),
        icon: "warning",
      })
    } else if (!declarations.dec1 || !declarations.dec2 || !declarations.dec4) {
      return
    } else {
      // if(gender.toUpperCase() === "MALE") {
      //   formValuesMale.user_id = userId 
      //   addDeclarationMale()
      // } else {
      //   formValuesFemale.user_id = userId
      //   addDeclarationFemale()
      // }
      submitProfileAndDocumentDetails()
    }
  }

  const addDeclarationMale = async () => {
    let userId = JSON.parse(localStorage.getItem('user_id'));
    setIsLoading(true)
    let params = {
      user_id: userId,
      date_of_birth: formValuesMale.date_of_birth,
      hair_loss_treatment: formValuesMale.hair_loss_treatment,
      medications: formValuesMale.medications,
      allergies: formValuesMale.allergies,
      hair_loss_duration: formValuesMale.hair_loss_duration,
      hair_loss_pattern: formValuesMale.hair_loss_pattern,
      psychological_state: formValuesMale.psychological_state,
      medical_history: formValuesMale.medical_history,
      scalp_conditions: formValuesMale.scalp_conditions
    }
    console.log('add_medical_history params', params);
    try {
      let res = await postApi('add_medical_history', params)
      console.log('add_medical_history res', res);
      if(res) {
        setIsLoading(false)
        // navigate('/clients', {state: {user_obj: location.state.user_obj}})
        // navigate('/prescriptions', {state: {user_obj: location.state.user_obj}})
        // submitProfileAndDocumentDetails()
        await trackEvent('health_declaration_submitted', 'success', "", localStorage.getItem('phno'))
        await gTagTracking('health_declaration_submitted', {
          action: 'success',
          error: '',
          mobile_number: localStorage.getItem('phno')
        })
        swal({
          title: i18next.t("Health declaration submitted successfully"),
          icon: "success",
        }).then((val) => {
          if(val) {
            localStorage.setItem("health_declaration_status", "true")
            navigate('/prescriptions')
          }
        });
      }
    } catch (err) {
      console.log("err", err);
      setIsLoading(false)
      await trackEvent('health_declaration_submitted', 'fail', err, localStorage.getItem('phno'))
      await gTagTracking('health_declaration_submitted', {
        action: 'fail',
        error: err,
        mobile_number: localStorage.getItem('phno')
      })
      serviceDown()
    }
  }

  const addDeclarationFemale = async () => {
    let userId = JSON.parse(localStorage.getItem('user_id'));
    setIsLoading(true)
    let params = {
      user_id: userId,
      date_of_birth: formValuesFemale.date_of_birth,
      menopause_state: formValuesFemale.menopause_state,
      start_of_hair_loss_during_menopause: formValuesFemale.start_of_hair_loss_during_menopause,
      hormone_therapy: formValuesFemale.hormone_therapy,
      hormone_sensitive_breast_cancer: formValuesFemale.hormone_sensitive_breast_cancer,
      history_of_endometriosis_or_uterine_fibroids: formValuesFemale.history_of_endometriosis_or_uterine_fibroids,
      depression_or_dosage_of_antidepressants: formValuesFemale.depression_or_dosage_of_antidepressants,
      allergies: formValuesFemale.allergies,
      dutasteride_allergy: formValuesFemale.dutasteride_allergy,
      medications: formValuesFemale.medications,
      other_medications: formValuesFemale.other_medications,
      hair_loss_treatment: formValuesFemale.hair_loss_treatment,
      scalp_conditions: formValuesFemale.scalp_conditions,
      recent_hair_products: formValuesFemale.recent_hair_products
    }
    console.log('add_medical_history_female params', params);
    try {
      let res = await postApi('add_medical_history_female', params)
      console.log('add_medical_history_female res', res);
      if(res) {
        setIsLoading(false)
        // navigate('/prescriptions', {state: {user_obj: location.state.user_obj}})
        // submitProfileAndDocumentDetails()
        await trackEvent('health_declaration_submitted', 'success', "", localStorage.getItem('phno'))
        await gTagTracking('health_declaration_submitted', {
          action: 'success',
          error: '',
          mobile_number: localStorage.getItem('phno')
        })
        swal({
          title: i18next.t("Health declaration submitted successfully"),
          icon: "success",
        }).then((val) => {
          if(val) {
            localStorage.setItem("health_declaration_status", "true")
            navigate('/prescriptions')
          }
        });
      }
    } catch (err) {
      console.log("err", err);
      setIsLoading(false)
      await trackEvent('health_declaration_submitted', 'fail', err, localStorage.getItem('phno'))
      await gTagTracking('health_declaration_submitted', {
        action: 'fail',
        error: err,
        mobile_number: localStorage.getItem('phno')
      })
      serviceDown()
    }
  }

  const submitProfileAndDocumentDetails = async () => {
    try { 
      setIsLoading(true)
      let userId = JSON.parse(localStorage.getItem('user_id'));

      const formData = gender.toUpperCase() === "MALE" ? formValuesMale : formValuesFemale;

      let params = {
        user_id: userId,
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,  
        document_type: formData.document_type,
        document_number: formData.document_number,
        document_issue_country: formData.document_issue_country
      }
      console.log('update_user_details params', params);
      let res = await postApi('update_user_details', params)
      console.log('update_user_details res', res);
      if(res?.error){
        setIsLoading(false)
        swal({
          title: i18next.t(res.error),
          icon: "warning",
        }).then(() => {
          return
        })
      } else {
        await trackEvent('profile_and_document_submitted', 'success', "", localStorage.getItem('phno'))
        await gTagTracking('profile_and_document_submitted', {
          action: 'success',
          error: '',
          mobile_number: localStorage.getItem('phno')
        })
        if(gender.toUpperCase() === "MALE") {
          addDeclarationMale()
        } else {
          addDeclarationFemale()
        }
      }
    } catch (err) {
      console.log("err", err);
      setIsLoading(false)
      await trackEvent('profile_and_document_submitted', 'fail', err, localStorage.getItem('phno'))
      await gTagTracking('profile_and_document_submitted', {
        action: 'fail',
        error: err,
        mobile_number: localStorage.getItem('phno')
      })
      serviceDown()
    }
  }

  return (
    <>
      {isLoading && <MainLoader/>}
      <div className='healthdeclarationpage photo-container main-section-container'>
        <Grid container spacing={0} className='d-flex justify-content-start align-items-center'>
          <Grid item xs={1} className=''>
            <div className='d-flex justify-content-start align-items-center'>
              <span className='backButtonDiv' onClick={() => navigate('/reports')}>
                <ArrowBackOutlinedIcon className='arrowBackBtn'></ArrowBackOutlinedIcon>
              </span>
            </div>
          </Grid>
          <Grid item xs={10} className='d-flex justify-content-center align-items-center '>
            <Typography variant="h6" className="title">{i18next.t("Health Declaration")}</Typography>
          </Grid>
          <Grid item xs={1} className='d-flex justify-content-center align-items-center'>
            <Sidebar/>
          </Grid>
        </Grid>
        <div className='progresscontainer'>
            <LinearProgress variant="determinate" value={progress}/>
            </div>
        <div className='healthdeclarationpage-questions-container'>
          {/* <div className='d-flex justify-content-start align-items-start patientCard mt-10px flex-direction-column'>
            <p><span className='p-main'>{i18next.t('Full Name: ')}</span>{`${location?.state?.user_obj?.first_name} ${location?.state?.user_obj?.last_name}`}</p>
            <p><span className='p-main'>{i18next.t('Year of Birth: ')}</span>{`${location?.state?.user_obj?.year_of_birth}`}</p>
            <p><span className='p-main'>{i18next.t('Gender: ')}</span>{`${location?.state?.user_obj?.gender}`}</p>
          </div> */}
          <div className='healthdeclarationquestioncontainer'>
            
            <div className='formMainComponent'>
              <>
                {/* {
                  location?.state?.user_obj.medical_history_present ? 
                    previewFormQuestions?.length > 0 && previewFormQuestions.map((ele) => {
                      return (
                        <Grid item xs={12} className='d-flex justify-content-start align-items-center'> 
                          <FormQuestionsPreview 
                            element={ele} 
                            handleFormValues={handleFormValues}
                            formQuestions={formQuestions}
                            formValues={formValues}
                            showQuesAns={true}
                          />   
                        </Grid>
                      )
                    })   
                      :
                    formQuestions?.length > 0 && formQuestions.map((ele) => {
                      return (
                        <Grid item xs={12} className='d-flex justify-content-start align-items-start'> 
                          <FormQuestions 
                            element={ele} 
                            handleFormValues={handleFormValues}
                            formQuestions={formQuestions}
                            formValues={formValues}
                          />   
                        </Grid>
                      )
                    })   
                } */}
                {
                  formQuestions?.length > 0 && formQuestions.map((ele, idx) => {
                    return (
                      <Grid item xs={12} className='d-flex justify-content-start align-items-center'>
                        <FormQuestions
                          key={idx}
                          element={ele}
                          handleFormValues={handleFormValues}
                          formQuestions={formQuestions}
                          formValues={gender.toUpperCase() === 'MALE' ? formValuesMale : formValuesFemale}
                        />
                      </Grid>
                    )
                  })
                }
              </>
            </div>
            <div className='formMainComponent d-flex justify-content-start align-items-start flex-direction-column'>
              <Typography variant="h6" className="userDetailsTitle mb-20px">
                {i18next.t(
                  locale === "en" ?
                    "Profile and Document Details" :
                  locale === "fr" ?
                    "Détails du profil et du document" :
                  locale === "es" ?
                    "Detalles de perfil y documento" 
                      :
                  "Profile and Document Details"
                )}
              </Typography>
              {/* <div className='userDetailsdiv'>
                <div className='quesContainer mb-20px'>
                  <p className='quesTitle mb-10px'>
                    {i18next.t("Full Name")}
                  </p>
                  <TextField
                    placeholder={i18next.t("Enter your full name")} 
                    variant="outlined"
                    className='w-100'
                  />
                </div>
                <div className='quesContainer mb-20px'>
                  <p className='quesTitle mb-10px'>
                    {i18next.t("Full Name")}
                  </p>
                  <TextField
                    placeholder={i18next.t("Enter your full name")} 
                    variant="outlined"
                    className='w-100'
                  />
                </div>


              </div> */}
              {
                finalUserDetailsQuestions?.length > 0 && finalUserDetailsQuestions.map((ele, idx) => {
                  return (
                    <Grid item xs={12} className='d-flex justify-content-start align-items-center w-100'>
                      <FormQuestions
                        key={idx}
                        element={ele}
                        handleFormValues={handleFormValues}
                        formQuestions={finalUserDetailsQuestions}
                        formValues={gender.toUpperCase() === 'MALE' ? formValuesMale : formValuesFemale}
                      />
                    </Grid>
                  )
                })
              }
            </div>
            {
              !location?.state?.user_obj.medical_history_present &&
                <>
                  <Grid item xs={12} className={!declarations.dec1 && submitClicked ? 'd-flex justify-content-start align-items-center unchecked' : 'd-flex justify-content-start align-items-center'}>
                    <FormGroup>
                      <FormControlLabel 
                        control={
                          <Checkbox 
                            onChange={(e) => handleDeclaration(e.target.checked, 'dec1')}
                          />
                        } 
                        label = {
                          locale === 'en' ?
                            'I can request a copy of my prescription at any time to inform my doctor about the medication prescribed for alopecia.' :
                          locale === 'fr' ?
                            'Je peux demander à tout moment une copie de mon ordonnance afin d’informer mon médecin traitant sur le médicament prescrit contre l’alopécie.' :
                          locale === 'es' ?
                            'Puedo solicitar en cualquier momento una copia de mi receta para informar a mi médico sobre el medicamento prescrito contra la alopecia.' 
                              :
                            'I can request a copy of my prescription at any time to inform my doctor about the medication prescribed for alopecia.'
                        }
                      />
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12} className={!declarations.dec2 && submitClicked ? 'd-flex justify-content-start align-items-center  mt-10px unchecked' : 'd-flex justify-content-start align-items-center  mt-10px'}>
                    <FormGroup>
                      <FormControlLabel 
                        control={
                          <Checkbox 
                            onChange={(e) => handleDeclaration(e.target.checked, 'dec2')}
                          />
                        } 
                        label = {
                          locale === 'en' ?
                            'I confirm that this treatment is for my personal and exclusive use. I commit to being the sole user.' :
                          locale === 'fr' ?
                            'Je confirme que ce traitement est destiné à mon usage personnel et exclusif. Je m’engage à être le seul utilisateur.' :
                          locale === 'es' ?
                            'Confirmo que este tratamiento es para mi uso personal y exclusivo. Me comprometo a ser el único usuario.'
                              :
                          'I confirm that this treatment is for my personal and exclusive use. I commit to being the sole user.'
                        }
                      />
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12} className='d-flex justify-content-start align-items-center  mt-10px'>
                    <FormGroup>
                      <FormControlLabel 
                        control={
                          <Checkbox 
                            onChange={(e) => handleDeclaration(e.target.checked, 'dec3')}
                          />
                        } 
                        label = {
                          locale === 'en' ?
                            'Are you aware of possible side effects of hair loss treatment and commit to reaching out to our doctors in case you notice any mood alterations or allergies.' :
                          locale === 'fr' ?
                            'Je m’engage à transmettre une fois par mois des photos de mon cuir chevelu afin d’évaluer l’efficacité du traitement et son éventuel ajustement.' :
                          locale === 'es' ?
                            'Me comprometo a enviar una foto de mi cuero cabelludo una vez al mes para evaluar la eficacia del tratamiento y su posible ajuste.' 
                              :
                          'Are you aware of possible side effects of hair loss treatment and commit to reaching out to our doctors in case you notice any mood alterations or allergies.'
                        }
                      />
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12} className={!declarations.dec4 && submitClicked ? 'd-flex justify-content-start align-items-center  mt-10px mb-20px unchecked' : 'd-flex justify-content-start align-items-center  mt-10px mb-20px'}>
                    <FormGroup>
                      <FormControlLabel 
                        control={
                          <Checkbox 
                            onChange={(e) => handleDeclaration(e.target.checked, 'dec4')}
                          />
                        } 
                        label = {
                          locale === 'en' ?
                            'I have read and understood the above questions and have answered them honestly and truthfully.' :
                          locale === 'fr' ?
                            'J’ai lu et compris les questions ci-dessus et y ai répondu de manière honnête et sincère.' :
                          locale === 'es' ?
                            'He leído y comprendido las preguntas anteriores y he respondido de manera honesta y veraz.'
                              :
                          'I have read and understood the above questions and have answered them honestly and truthfully.'
                        }
                      />
                    </FormGroup>
                  </Grid>
                </>
            }
          </div>
          {
            !location?.state?.user_obj.medical_history_present &&
              <Button className='submitButton commonButton mt-10px' variant="contained" onClick={handleSubmit}>
                {i18next.t("Submit")}
              </Button>
          }
        </div>
      </div>
    </>
  )
}

export default HealthDeclaration